import { fontSizes } from '@opallabs/pulsar'
import { sharedColors } from '../sharedStyles'

const helveticaBold = 'Helvetica-Bold'

const iconWrapper = {
  position: 'absolute',
  width: '34px',
  height: '34px',
  background: sharedColors.white(0.2),
  borderRadius: '99px',
  display: 'flex',
  justifyContent: 'center',
}

const assetIconStyles = {
  style: {
    color: sharedColors.white(),
    height: '14px',
    width: '14px',
  },
}

const assetContainer = {
  background: sharedColors.black(),
  width: '517px',
  height: '100%',
  position: 'relative',
  closeIcon: {
    ...iconWrapper,
    top: '14px',
    left: '14px',
  },
  chevronWest: {
    ...iconWrapper,
    top: '265px',
    left: '14px',
  },
  chevronEast: {
    ...iconWrapper,
    top: '265px',
    right: '14px',
  },
}

const postContent = {
  background: sharedColors.white(),
  width: '383px',
  height: '100%',
}

const postHeader = {
  padding: '38px 24px 12px 24px',
  display: 'flex',
  justifyContent: 'space-between',
  '& > div:first-of-type': {
    display: 'flex',
    flex: '1 1 auto',
    marginRight: 12,
    minWidth: 0,
    overflow: 'hidden',
  },
  '& > div:last-of-type': {
    flexShrink: 0,
  },
}

const nameAndSubAccount = {
  minWidth: 0,
  overflow: 'hidden',
}

const avatar = {
  flexShrink: 0,
  marginRight: '8px',
  img: {
    height: '100%',
    objectFit: 'cover',
  },
}

const accountName = {
  fontFamily: helveticaBold,
  fontSize: fontSizes.xSmall,
  fontWeight: 'bold',
  letterSpacing: '0px',
  width: '205px',
}

const subAccountName = (username) => ({
  fontSize: fontSizes.xxSmall - 2,
  color: sharedColors.textColor,
  'span:first-of-type': {
    color: username ? sharedColors.textColor : sharedColors.orange,
  },
})

const bulletPoint = {
  fontSize: '5px',
  top: '-2px',
  marginLeft: '1px',
  position: 'relative',
}

const followButton = {
  width: '88px',
  height: '26px',
  border: `1px solid ${sharedColors.pink}`,
  borderRadius: '1px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  p: {
    color: sharedColors.pink,
    fontFamily: helveticaBold,
    fontSize: '12px',
    fontWeight: 'bold',
    letterSpacing: '0px',
    textAlign: 'center',
  },
}

const postInputs = {
  width: '335px',
  padding: '0 24px 14px 24px',
  soundWrapper: {
    display: 'flex',
  },
  soundIcon: {
    style: {
      height: '11px',
      marginRight: '3px',
      width: '11px',
    },
  },
  soundInput: {
    fontWeight: 600,
    width: 316,
    fontSize: 12,
  },
  placeholderInput: {
    width: 'calc(100% - 10px)',
  },
  captionInput: {
    fontSize: 11,
    padding: '3px 0',
  },
}

const postShareBar = {
  display: 'flex',
  padding: '0 24px',
  justifyContent: 'space-between',
  ul: {
    listStyleType: 'none',
    display: 'flex',
    '&:first-of-type': {
      li: {
        display: 'flex',
        alignItems: 'center',
        p: {
          marginLeft: '8px',
          fontSize: '15px',
        },
        '&:first-of-type': {
          marginRight: '13px',
        },
      },
    },
  },
  // Necessary for SVG fill=currentColor to propagate properly
  'ul.tiktok-social-icons': {
    color: 'white',
  },
}

const socialIcon = {
  style: {
    width: '22px',
    height: '22px',
    marginLeft: '6px',
  },
}

const withCollab = 'with-collab'
const withCollabSelector = `.kuiper-${withCollab}`

const nameRow = {
  alignItems: 'baseline',
  display: 'flex',
  [`&${withCollabSelector}`]: {
    minWidth: 0,
    overflow: 'hidden',
  },
  [`&${withCollabSelector} .kuiper-account-name`]: {
    ...accountName,
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 'auto',
  },
}

const collabSeparator = {
  flexShrink: 0,
  fontFamily: accountName.fontFamily,
  fontSize: accountName.fontSize,
  fontWeight: 'normal',
  whiteSpace: 'pre',
}

export const styles = {
  avatar,
  accountName,
  assetContainer,
  assetIconStyles,
  collabSeparator,
  nameAndSubAccount,
  nameRow,
  postContent,
  postHeader,
  postInputs,
  postShareBar,
  followButton,
  subAccountName,
  bulletPoint,
  socialIcon,
  withCollab,
}
